// extracted by mini-css-extract-plugin
module.exports = {"Status":"Status_Status__KUr5i","Blue":"Status_Blue__2a_p8","Yellow":"Status_Yellow__8m5q6","Orange":"Status_Orange__1UBs6","Green":"Status_Green__1N0Ch","Red":"Status_Red__2Ljp4"};